import { render } from "./InputTextarea.vue?vue&type=template&id=00253305&scoped=true"
import script from "./InputTextarea.vue?vue&type=script&lang=js"
export * from "./InputTextarea.vue?vue&type=script&lang=js"

import "./InputTextarea.vue?vue&type=style&index=0&id=00253305&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00253305"]])

export default __exports__